import React from "react";
import PropTypes from "prop-types";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveSetupStepInfo = ({ currentStep, stepsCount }) => (
  <GridItem gridColumn="8" gridRow="2" marginTop={4}>
    <Text size="small" fontWeight="medium" as="h2" textAlign="right">
      {`${currentStep} / ${stepsCount}`}
    </Text>
  </GridItem>
);

LiveSetupStepInfo.propTypes = {
  currentStep: PropTypes.number.isRequired,
  stepsCount: PropTypes.number.isRequired,
};

export default LiveSetupStepInfo;
